export const MEASURING_UNITS = [
  { key: "PIECE", labelKey: "MeasuringUnitPiece" },
  { key: "ML", labelKey: "MeasuringUnitMl" },
  { key: "TABLET", labelKey: "MeasuringUnitTablet" },
  { key: "VIAL", labelKey: "MeasuringUnitVial" },
  { key: "AMPOULE", labelKey: "MeasuringUnitAmpoule" },
  { key: "TEN_GRAMS", labelKey: "MeasuringUnitTenGrams" },
  { key: "BLISTER", labelKey: "MeasuringUnitBlister" },
];

export function getMeasuringUnitLabel(key, t) {
  if (!key) {
    return null;
  }
  const unit = MEASURING_UNITS.find((u) => u.key === key);
  return unit ? t(unit.labelKey) : key;
}
